import Vue from 'vue'
import Vuex from 'vuex'
import { testPlatform } from "@/utils";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId: '',
    version: {},
    user: {
      id: '',
      nick: '',
      token: '',
      avatar: '',
      mobile: '',
      sex: '',
      addr: ''
    },
    token: '',
    query: {
      channel: 'main'
    },
    contactActive: 0,
    serviceEntrance:{
      requestStatus: 0,// 0:未请求 1:请求成功 2:请求失败
      on: false // 是否显示我要反馈、账号申述入口
    }
  },
  getters: {
    getParams: state => {
      let params = Object.create(null)
      params.cur_user_id = state.user.id
      params.userId = state.user.id
      params.token = state.token
      return () => Object.assign({}, params)
    },

    getQuery: state => state.query,

    getVersion: state => state.version,

    getUser: state => {
      return Object.assign({}, state.user)
    },

    getImgBaseUrl: state => state.imgBaseUrl,

    getNewImgBaseUrl: state => state.newImgBaseUrl,

    getQuestionList: state => state.questionList,

    getContactActive: state => state.contactActive,

    getServiceEntranceOn: state => state.serviceEntrance.on,

    getServiceEntranceRequestStatus: state => state.serviceEntrance.requestStatus
  },
  mutations: {
    setMemberInfo(state, info) {
      // 保存客户端下发的完整用户信息，供详情页在接口无返回时回退取值
      state.user = {
        ...state.user,
        ...info,
        id: info.userId || info.id || state.user.id,
        avatar: info.avatar || 'https://bsyimg.pandapaint.net/avatar/default/default_head_image.png',
        token: info.token || state.user.token,
        mobile: info.mobile || info.phone || state.user.mobile || '',
        sex: info.sex,
        addr: info.addr || info.address || state.user.addr || ''
      }
      state.userId = info.userId || info.id || state.userId
      state.token = info.token || state.token
    },
    setVer(state, { ver, verName }) {
      if (testPlatform("ios")) {
        ver = {verCode: state.query.version_code, verName: verName};
        // state.version.verCode = state.query.version_code;
      }
      state.version = ver
      if (!state.query.version_name) {
        Vue.set(state.query, 'version_name', verName)
      }
    },
    setQuery(state, info) {
      state.query = { ...state.query, ...info }
      if (testPlatform("ios") && !state.version.verCode) {
        Vue.set(state.version, 'verCode', info.version_code)
      }
    },

    getVersion: state => state.version,

    setProfile(state, info){
      const serviceEntranceObj = info.find(item => parseInt(item.type) === 33)||0;
      state.serviceEntrance.on = parseInt(serviceEntranceObj.val) !== 2;
    },
    setProfileRequestStatus(state, info) {
      state.serviceEntrance.requestStatus = parseInt(info);
    }
  },
  actions: {
    
  },
  modules: {
  }
})
